import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  loaded: false,
  error: false,
  property: {},
  theme: {},
  initialLoad: true,
  term: {},
  filters: {},
  totalResults: 0,
  detailApi: undefined
};

const getters = {
  read: state => prop => {
    return state[prop];
  }
};

const mutations = {
  set_loaded: (state, payload) => {
    state.loaded = payload;
  },
  set_error: (state, payload) => {
    state.error = payload;
  },
  set_property: (state, payload) => {
    state.property = payload;
  },
  set_initialLoad: (state, payload) => {
    state.initialLoad = payload;
  },
  set_theme: (state, payload) => {
    state.theme = payload;
  },
  set_term: (state, payload) => {
    state.term = payload;
  },
  set_storeTerm: (state, payload) => {
    state.property.Terms.push(payload);
  },
  set_filters: (state, payload) => {
    if (payload.hasOwnProperty("multi")) {
      if (Array.isArray(payload.multi)) {
        Vue.set(state.filters, payload.filter, payload.multi);
      } else if (payload.multi.value === null) {
        Vue.set(state.filters, payload.filter, [payload.multi]);
      } else {
        let exists = false;
        let selections = state.filters[payload.filter].reduce(
          (_selections, filter) => {
            if (filter.value === null) {
              return _selections;
            }
            if (filter.value == payload.multi.value) {
              exists = true;
              return _selections;
            }
            _selections.push(filter);
            return _selections;
          },
          []
        );
        if (!exists || !selections.length) {
          selections.push(payload.multi);
        }
        Vue.set(state.filters, payload.filter, selections);
      }
    } else if (payload.hasOwnProperty("text")) {
      Vue.set(state.filters, payload.filter, {
        value: payload.value,
        text: payload.text
      });
    } else {
      Vue.set(state.filters, payload.filter, { value: payload.value });
    }
  },
  set_clear_filters: (state) => {
    Vue.set(state, 'filters', {})
  },
  set_totalResults: (state, payload) => {
    state.totalResults = payload;
  },
  set_detailApi: (state, payload) => {
    state.detailApi = payload;
  }
};

const actions = {
  set: ({ commit }, payload) => {
    let muta = `set_${payload.muta}`;
    commit(muta, payload.data);
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
